import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import gql from 'graphql-tag';

import { GetPresignedUploadUrl } from '../../../athena/types/GetPresignedUploadUrl';

export const QUERY = gql`
  query GetPresignedUploadUrl($maintenanceRequestId: String!, $fileName: String!) {
    webMaintenance {
      getPresignedUploadUrl(
        input: { maintenanceRequestId: $maintenanceRequestId, fileName: $fileName }
      ) {
        presignedUploadUrl
        key
      }
    }
  }
`;

const useGetPresignedUploadUrl = (options?: QueryHookOptions<GetPresignedUploadUrl>) =>
  useQuery<GetPresignedUploadUrl>(QUERY, options);

export default useGetPresignedUploadUrl;
